// removed by extract-text-webpack-plugin
module.exports = {"container":"eH_Rhdp429EQHUZK8nWNt","Icon":"_-5WkpyPApN1B54Pi4ENBA","Title":"_1oCGUCzQ7nSeK2ze54lmDQ"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/PubDocumentVerify/DocVerifier/Verify/Actions/styles.css
// module id = 3023
// module chunks = 0